import { SelectField } from '@/components/form/fields/SelectField';
import React from 'react';
import { TextAreaField } from '@/components/form/fields/TextAreaField';
import { IDropDown } from '@/api/testIssue';
import { SelectTreeField } from '@/components/form/fields/SelectTreeField';
import { IDetailTestRunSchema } from '@/api/testRunDetail';
import { InputField } from '@/components/form/fields/InputField';
import { NumberedStepsField } from './NumberedStepsField';

type TestIssueProps = {
  optionsData?: IDropDown;
  testRunDetailData?: IDetailTestRunSchema;
};

export const TestIssueForm: React.FC<TestIssueProps> = ({
  optionsData,
  testRunDetailData,
}) => {
  return (
    <div className="grid gap-2.5">
      <div className="flex gap-5">
        <TextAreaField
          name="title"
          label="Issue title"
          placeholder="Enter issue title"
          hasRequiredAsterisk
        />

        <TextAreaField
          name="description"
          label="Description"
          placeholder="Enter issue description"
          hasRequiredAsterisk
        />
      </div>

      <div className="flex gap-5">
        <SelectField
          options={optionsData?.category}
          name="category"
          label="Category"
          hasRequiredAsterisk
          isSearchable
        />

        <SelectField
          options={optionsData?.environment}
          name="environment_issue"
          label="Environment"
          hasRequiredAsterisk
          isSearchable
        />
      </div>

      <div className="flex gap-5">
        <SelectField
          options={optionsData?.issue_type}
          name="issue_type"
          label="Issue Type"
          hasRequiredAsterisk
          isSearchable
        />
        <SelectField
          options={optionsData?.priority}
          name="priority"
          label="Priority"
          hasRequiredAsterisk
          isSearchable
        />
      </div>

      <div className="flex gap-5">
        <SelectField
          options={optionsData?.assignee_issue}
          name="assignee_issue"
          label="Assigned to"
          hasRequiredAsterisk
          isSearchable
        />
        <SelectField
          options={optionsData?.severity}
          name="severity"
          label="Severity"
          hasRequiredAsterisk
          isSearchable
        />
      </div>
      <div className="flex gap-5">
        <SelectField
          options={optionsData?.release}
          name="release_id"
          label="Release"
          hasRequiredAsterisk
          isSearchable
        />

        {testRunDetailData?.test_case?.module ? (
          <InputField
            name="module.module_name"
            label="Module"
            type="text"
            defaultValue={testRunDetailData?.test_case?.module?.module_name}
            disabled
          />
        ) : (
          <SelectTreeField
            name="module_id"
            label="Module"
            options={optionsData?.module}
            filter
          />
        )}
      </div>

      <div className="flex gap-5">
        <SelectField
          options={optionsData?.test_run}
          name="test_run_id"
          label="Test Run"
          placeholder="Select Test Run"
          isSearchable
        />
      </div>

      <NumberedStepsField
        name="step_issue"
        label="Steps to Reproduce"
        placeholder={`Enter steps to reproduce, e.g.\n1. Go to...\n2. Click on...\n3. See error...`}
      />
    </div>
  );
};
